import {
  AlertCircle,
  Home,
  LogIn,
  RefreshCw,
} from "lucide-react"
import { useContext } from "react"
import {
  useNavigate,
  useRouteError,
} from "react-router-dom"

import { Button } from "@/components/ui/button"
import { FRONTEND_ROUTES } from "@/constants"
import { AuthContext } from "@/contexts/auth"

export const ErrorBoundary = () => {
  const error = useRouteError() as Error & {
    status?: number
  }
  const navigate = useNavigate()
  const authContext = useContext(AuthContext)
  const isAuthenticated =
    !!authContext?.authData?.accessToken

  const is404 = error?.status === 404
  const is401or403 =
    error?.status === 401 || error?.status === 403

  const handleGoToLogin = () => {
    navigate(FRONTEND_ROUTES.LOGIN.href)
  }

  const handleGoHome = () => {
    if (isAuthenticated) {
      navigate(FRONTEND_ROUTES.DASHBOARD.href)
    } else {
      navigate(FRONTEND_ROUTES.LOGIN.href)
    }
  }

  const handleRefresh = () => {
    window.location.reload()
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <div className="w-full max-w-md space-y-6 text-center">
        <div className="flex justify-center">
          <div className="flex h-20 w-20 items-center justify-center rounded-full bg-destructive/10">
            <AlertCircle className="h-10 w-10 text-destructive" />
          </div>
        </div>

        <div className="space-y-2">
          <h1 className="text-3xl font-bold tracking-tight">
            {is404
              ? "Página não encontrada"
              : "Algo deu errado"}
          </h1>
          <p className="text-muted-foreground">
            {is404
              ? "A página que você está procurando não existe ou foi movida."
              : is401or403
                ? "Sua sessão expirou. Por favor, faça login novamente."
                : "Ocorreu um erro inesperado. Tente novamente mais tarde."}
          </p>
        </div>

        {import.meta.env.DEV && error?.message && (
          <div className="rounded-lg bg-muted p-4 text-left">
            <p className="text-sm font-medium text-destructive">
              Detalhes do erro (dev):
            </p>
            <p className="mt-1 text-xs text-muted-foreground">
              {error.message}
            </p>
          </div>
        )}

        <div className="flex flex-col gap-3">
          {is401or403 ? (
            <Button
              onClick={handleGoToLogin}
              className="w-full"
              size="lg"
            >
              <LogIn className="mr-2 h-4 w-4" />
              Ir para Login
            </Button>
          ) : (
            <>
              <Button
                onClick={handleGoHome}
                className="w-full"
                size="lg"
              >
                <Home className="mr-2 h-4 w-4" />
                {isAuthenticated
                  ? "Ir para Dashboard"
                  : "Ir para Login"}
              </Button>
              <Button
                onClick={handleRefresh}
                variant="outline"
                className="w-full"
                size="lg"
              >
                <RefreshCw className="mr-2 h-4 w-4" />
                Recarregar Página
              </Button>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
